module.exports = __webpack_public_path__ + "static/drow_arachnomancer-74e5b4584fd50f770da27ee6aef797c5.png";